"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valfloriana": {
    "9c537f48": [{
      "hkey": "4f3738b1",
      "slug": "valfloriana",
      "name": "Valfloriana",
      "primary": true,
      "skipSearch": false
    }],
    "ischiazza": [{
      "hkey": "4f3738b1",
      "slug": "valfloriana",
      "name": "Valfloriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f37375cb": [{
      "hkey": "4f3738b1",
      "slug": "valfloriana",
      "name": "Valfloriana",
      "primary": true,
      "skipSearch": false
    }],
    "maso": [{
      "hkey": "4f3738b1",
      "slug": "valfloriana",
      "name": "Valfloriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1fb7d8f3": [{
      "hkey": "4f3738b1",
      "slug": "valfloriana",
      "name": "Valfloriana",
      "primary": true,
      "skipSearch": false
    }],
    "palu": [{
      "hkey": "4f3738b1",
      "slug": "valfloriana",
      "name": "Valfloriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "451ccb0b": [{
      "hkey": "4f3738b1",
      "slug": "valfloriana",
      "name": "Valfloriana",
      "primary": true,
      "skipSearch": false
    }],
    "pradel": [{
      "hkey": "4f3738b1",
      "slug": "valfloriana",
      "name": "Valfloriana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;